module.exports = __webpack_public_path__ + "static/media/landingPage_General.d54347d5.md";